import React from 'react'
import { components } from 'react-select'

const SelectPlaceholder = props => {
  const { children } = props

  return <components.Placeholder {...props} children={children} />
}

export default SelectPlaceholder
